const textAlign = {
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: 'center',
  JUSTIFY: 'justify',
  START: 'start',
  END: 'end'
} as const

export type TextAlignType = (typeof textAlign)[keyof typeof textAlign]

export const convertToTextAlignType = (
  value: string | undefined
): TextAlignType => {
  switch (value) {
    case 'left':
      return textAlign.LEFT
    case 'right':
      return textAlign.RIGHT
    case 'center':
      return textAlign.CENTER
    case 'justify':
      return textAlign.JUSTIFY
    case 'start':
      return textAlign.START
    case 'end':
      return textAlign.END
    default:
      return textAlign.LEFT
  }
}

export default textAlign
